export const PenOnPaperIcon: React.FC<{ color?: string; className?: string }> = ({ color, className }) => {
  const stroke = color || '#1F74B6'

  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_12437_139977)'>
        <path
          d='M7.41533 9.55815L5.25 9.86732L5.55917 7.69965L11.1277 2.13115C11.2497 2.00928 11.3945 1.91263 11.5539 1.84673C11.7133 1.78083 11.8841 1.74696 12.0566 1.74707C12.229 1.74718 12.3998 1.78126 12.5591 1.84736C12.7184 1.91346 12.8631 2.01029 12.985 2.13232C13.1069 2.25435 13.2035 2.39919 13.2694 2.55858C13.3353 2.71796 13.3692 2.88876 13.3691 3.06123C13.369 3.2337 13.3349 3.40446 13.2688 3.56376C13.2027 3.72306 13.1059 3.86778 12.9838 3.98965L7.41533 9.55815Z'
          stroke={stroke}
          strokeWidth='0.95'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.0625 8.75H1.3125C1.08044 8.75 0.857876 8.84219 0.693782 9.00628C0.529687 9.17038 0.4375 9.39294 0.4375 9.625V11.375C0.4375 11.6071 0.529687 11.8296 0.693782 11.9937C0.857876 12.1578 1.08044 12.25 1.3125 12.25H12.6875C12.9196 12.25 13.1421 12.1578 13.3062 11.9937C13.4703 11.8296 13.5625 11.6071 13.5625 11.375V9.625C13.5625 9.39294 13.4703 9.17038 13.3062 9.00628C13.1421 8.84219 12.9196 8.75 12.6875 8.75H10.9375'
          stroke={stroke}
          strokeWidth='0.95'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_12437_139977'>
          <rect width='14' height='14' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
